<template>
  <div
    v-if="loadingDetail"
    class="eu-pa_6 eu-align_center"
  >
    <emd-loader :type="'_invert'" />
  </div>
  <div
    v-else
    class="el-section"
  >
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('webhook.response.title') }}
        </h2>
      </div>
      <div
        class="el-chunk"
        v-if="!webhook.responses.length"
      >
        <empty-list
          class=""
          entity="webhooks"
        ></empty-list>
      </div>
      <div
        v-else
        class="emd-card-grid"
        v-for="(response, index) in webhook.responses"
        :key="index"
      >
        <div class="emd-card-grid__content">
          <div class="eu-clearfix">
            <div class="eu-float_left">
              <h2
                class="emd-text _type_caption eu-pb_2 eu-pr_2 eu_no_padding_sm"
              >
                {{ $t('webhook.response.attempt') }} {{ response.attempt }}
              </h2>
            </div>
          </div>
        </div>
        <div class="emd-card-grid__row">
          <div class="emd-card-grid__column">
            <label class="emd-text _type_label _size_tiny _color_subtle">{{
              $t('webhook.response.status-code')
            }}</label>
            <p class="emd-card-grid__line">{{ response.status_code || '-' }}</p>
          </div>
          <div class="emd-card-grid__column">
            <label class="emd-text _type_label _size_tiny _color_subtle">{{
              $t('webhook.response.success')
            }}</label>
            <p class="emd-card-grid__line">{{ response.success }}</p>
          </div>
          <div class="emd-card-grid__column">
            <label class="emd-text _type_label _size_tiny _color_subtle">{{
              $t('webhook.response.time')
            }}</label>
            <p
              class="emd-card-grid__line"
              v-if="response.time"
            >
              {{ response.time }}ms
            </p>
            <p
              class="emd-card-grid__line"
              v-else
            >
              -
            </p>
          </div>
          <div class="emd-card-grid__column">
            <label class="emd-text _type_label _size_tiny _color_subtle">{{
              $t('webhook.response.created-at')
            }}</label>
            <p class="emd-card-grid__line">
              {{ response.created_at | dateFormat('dateAndHour') }}
            </p>
          </div>
          <div class="emd-card-grid__column _size_100">
            <label class="emd-text _type_label _size_tiny _color_subtle">{{
              $t('webhook.response.raw')
            }}</label>
            <div class="eu-pt_1">
              <pre>{{ response.raw || '-' }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import EmptyList from '@/components/project/globals/EmptyList.vue'
export default {
  name: 'WebhookResponse',
  components: {
    EmdLoader,
    EmptyList
  },
  data () {
    return {
      webhook: {},
      loadingDetail: true
    }
  },
  computed: {
    params () {
      return {
        merchantId: this.$store.getters.merchantId,
        accountId: this.$store.getters.accountId,
        webhookId: this.$route.params.id
      }
    }
  },
  methods: {
    getWebhook () {
      this.params.query = {
        fields: 'responses{raw,status_code,success,attempt,time,created_at}'
      }
      this.$store.dispatch('GET_WEBHOOK', this.params).then(res => {
        this.loadingDetail = false
        this.webhook = res
      })
    }
  },
  created () {
    this.getWebhook()
  }
}
</script>
